import PayOverTimeTransactionDetails from 'features/payOverTime/screens/TransactionDetails/PayOverTimeTransactionDetails';
import React from 'react';

export default function Page() {
  return <PayOverTimeTransactionDetails />;
}
